import * as React from 'react';
import * as ReactDOM from 'react-dom';
import authService from './api-authorization/AuthorizeService';
import { Stack, StackItem, IStackTokens } from "@fluentui/react/lib/Stack";
import { TextField } from "@fluentui/react/lib/TextField";
import { DatePicker, IDatePickerStrings } from "@fluentui/react/lib/DatePicker";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { Link } from "@fluentui/react/lib/Link";
import { Label } from '@fluentui/react/lib/Label';
import { DayOfWeek } from '@fluentui/date-time-utilities';
import { ChoiceGroup, IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
import { TagPicker, IBasePicker, ITag, IInputProps, IBasePickerSuggestionsProps, ISuggestionItemProps } from '@fluentui/react/lib/Pickers';
//import { Checkbox } from "@fluentui/react/lib/Checkbox";
import { DefaultButton, PrimaryButton, MessageBarButton } from '@fluentui/react/lib/Button';
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import { Separator } from '@fluentui/react/lib/Separator';
import { getTheme, mergeStyleSets, getFocusStyle } from "@fluentui/style-utilities";
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { DetailsList, DetailsListLayoutMode, Selection, IColumn, SelectionMode, ConstrainMode } from '@fluentui/react/lib/DetailsList';
//import { MessageBar, MessageBarType } from '@fluentui/react/lib/MessageBar';
//import { ComboBox, IComboBox, IComboBoxOption } from '@fluentui/react/lib/ComboBox';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
//import MaterialInput from '@material-ui/core/Input';
import { Icon } from '@fluentui/react/lib/Icon';
//import { EventBus, Registry } from '../utilities/EventBus';
import { CommonModels } from "../models/CommonModels";
import * as $ from 'jquery';
import 'jquery-mask-plugin';

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');

const theme = getTheme();
const { palette, semanticColors, fonts } = theme;
const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
        textAlign: "left"
    },
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});
const wrapTokens: IStackTokens = { childrenGap: 15 };
const baseURL: String = window.location.host;

//let eventListener: Registry;

let required: Array<CommonModels.KeyValuePair> = [
    { key: "pt_noticecasesource", value: "Notice Filed on Behalf of is required" },
    { key: "pt_noticeemployer", value: "Employer Information - Organization Name is required" },
    { key: "pt_noticeemployeraddressline1", value: "Employer Information - Address line 1 is required" },
    { key: "pt_noticeemployercity", value: "Employer Information - City is required" },
    { key: "pt_noticeemployerstate", value: "Employer Information - State is required" },
    { key: "pt_noticeemployerzip", value: "Employer Information - Zip is required" },
    { key: "pt_noticeindustry", value: "Employer Information - Industry is required" },
    { key: "pt_nsector", value: "Employer Information - Work Sector is required" },
    { key: "pt_nemployercontactfirstname", value: "Employer Chief Negotiator or Labor Relations Director - First name is required" },
    { key: "pt_nemployercontactlastname", value: "Employer Chief Negotiator or Labor Relations Director - Last name is required" },
    { key: "pt_noticeemployeremail", value: "Employer Chief Negotiator or Labor Relations Director - Business Email is required" },
    { key: "pt_noticeemployeremail_confirm", value: "Employer Chief Negotiator or Labor Relations Director - Confirmation Email is required" },
    { key: "pt_noticeemployerphone", value: "Employer Chief Negotiator or Labor Relations Director - Phone is required" },
    //{ key: "pt_noticeunion", value: "CBA and Bargaining Unit Information - Union Full Name is required" },
    { key: "pt_noticecategory", value: "CBA and Bargaining Unit Information - Type of Notice is required" },
    //{ key: "pt_nbargainingunitsize", value: "CBA and Bargaining Unit Information - Estimated Bargaining Unit Size is required" },
    { key: "pt_noticenegotiationcity", value: "Location of Negotiation City is required" },
    { key: "pt_noticenegotiationstate", value: "Location of Negotiation State is required" },
    { key: "pt_noticenegotiationzip", value: "Location of Negotiation Zip is required" },
    { key: "pt_noticeunionaddressline1", value: "Union Information - Address line 1 is required" },
    { key: "pt_noticeunioncity", value: "Union Information - City is required" },
    { key: "pt_noticeunionstate", value: "Union Information - State is required" },
    { key: "pt_noticeunionzip", value: "Union Information - Zip is required" },
    { key: "pt_nunioncontactfirstname", value: "Union Chief Negotiator or Business Agent - First Name is required" },
    { key: "pt_nunioncontactlastname", value: "Union Chief Negotiator or Business Agent - Last name is required" },
    { key: "pt_noticeunionemail", value: "Union Chief Negotiator or Business Agent - Business Email is required" },
    { key: "pt_noticeunionemail_confirm", value: "Union Chief Negotiator or Business Agent - Confirmation Email is required" },
    { key: "pt_noticeunionphone", value: "Union Chief Negotiator or Business Agent - Phone is required" },
    { key: "pt_nfilerfirstname", value: "Official Filing This Notice - First Name is required" },
    { key: "pt_nfilerlastname", value: "Official Filing This Notice - Last Name is required" },
    { key: "pt_nfilertitle", value: "Official Filing This Notice - Title is required" },
    { key: "pt_nfileremail", value: "Official Filing This Notice - Business Email is required" },
    { key: "pt_nfileremail_confirm", value: "Official Filing This Notice - Confirmation Email is required" },
    { key: "pt_nfilerphone", value: "Official Filing This Notice - Primary Phone is required" }
];
let invalid: Array<CommonModels.KeyValuePair> = [];
let token;

const addressColumns = [
    { key: 'address', name: '', fieldName: 'freeformAddress', minWidth: 250, isResizable: true }
];

enum zipValidationStatusOptions { ValidZip = 692220003, InvalidZip = 692220001, MissinginCRM = 692220000 };

interface F7ControlState {
    formState: CommonModels.FormState,
    formSubmitted: boolean,
    casecategory: Array<CommonModels.KeyValuePair>,
    casesource: Array<CommonModels.KeyValuePair>,
    industry: Array<CommonModels.KeyValuePair>,
    sectors: Array<CommonModels.KeyValuePair>,
    unions: Array<CommonModels.Union>,
    states: Array<CommonModels.State>,
    //bargainingunitsizes: Array<CommonModels.BargainingUnitSize>,
    //f7submissions: Array<any>,
    //user?: any,
    attachment?: any,
    errorMessages: [],
    f7record?: any,
    //dismissClonePrompt: boolean,
    //cloneModalHidden: boolean,
    //cloneModalLoading: boolean,
    //selectionCount: number,
    //selection: Array<any>,
    //employerAddressSame: boolean,
    //unionAddressSame: boolean,
    dialogHidden: boolean,
    //dialogResetHidden: boolean,
    pt_noticeunion_selectedItems: Array<ITag>,
    pt_noticeemployerstate_selectedItems: Array<ITag>,
    pt_nemployercontactstate_selectedItems: Array<ITag>,
    pt_noticeunionstate_selectedItems: Array<ITag>,
    pt_nunioncontactstate_selectedItems: Array<ITag>,
    pt_noticeaffectedstate_selectedItems: Array<ITag>,
    pt_noticenegotiationstate_selectedItems: Array<ITag>,
    pt_noticecategory: string,
    pt_noticecategorylabel?: string,
    pt_noticeemployer?: string,
    pt_noticeemployeraddressline1?: string,
    pt_noticeemployeraddressline2?: string,
    pt_noticeemployercity?: string,
    pt_noticeemployerstate?: string,
    pt_noticeemployerzip?: string,
    pt_nemployercontactfirstname?: string,
    pt_nemployercontactlastname?: string,
    pt_noticeemployerphone?: string,
    pt_nemployerphoneext?: string,
    pt_noticecasesource: string,
    pt_noticeemployeremail?: string,
    pt_noticeemployeremail_confirm?: string,
    pt_noticeexpirationdate: Date,
    pt_noticereopenerdate: Date,
    pt_noticeindustry?: string,
    pt_noticeunion?: string,
    pt_noticeunionother?: string,
    pt_noticeunionnumber?: string,
    pt_noticeunionaddressline1?: string,
    pt_noticeunionaddressline2?: string,
    pt_noticeunioncity?: string,
    pt_noticeunionstate?: string,
    pt_noticeunionzip?: string,
    //pt_nunionid?: string,
    pt_nunioncontactfirstname?: string,
    pt_nunioncontactlastname?: string,
    pt_noticeunionphone?: string,
    pt_nunioncontactphoneext?: string,
    pt_noticeunionemail?: string,
    pt_noticeunionemail_confirm?: string,
    pt_nfilerfirstname?: string,
    pt_nfilerlastname?: string,
    pt_nfilertitle?: string,
    pt_nfileremail?: string,
    pt_nfileremail_confirm?: string,
    pt_nfilerphone?: string,
    pt_nfilerphoneext?: string,
    pt_noticecasetype?: string,
    pt_notices: number,
    pt_noticenegotiationcity?: string,
    pt_noticenegotiationstate?: string,
    pt_noticenegotiationzip?: string,
    pt_noticebu?: number,
    pt_nreceiveddate: Date,
    pt_receiveddate: Date,
    pt_reopenerdate?: Date,
    ////pt_nbargainingunitsizeText: string,

    pt_nemployerwebsite?: string,
    pt_nsector: string,
    pt_nsectorlabel?: string,
    pt_nunionacronym?: string,
    pt_nprimaryfunctionofbargainingunitemployees?: string,
    ////pt_nbargainingunitsize?: string,

    pt_f7noticesubmissionformat: number,
    additionalNoticesId?: string,
    //filters: Array<CommonModels.KeyValuePair>,
    //filterYear: number,
    //userFilters: Array<CommonModels.Filter>,
    //f7Filter: number,

    addressSearchMinLength: number,
    azMapsKey: string,
    addresssGeocodeServiceUrlTemplate: string,
    azMapsLanguage: string,
    azMapsCoutrySet: string,
    searchAddresses: Array<CommonModels.searchAddress>,
    eCalloutVisible: boolean,
    uCalloutVisible: boolean;
    isLoaded: boolean,
    controlCallback?: (newValue: any) => void,
    employerAddressSearchId: string,
    unionAddressSearchId: string,
    isSuccessorContract: boolean,
    isContractReopener: boolean,
    pt_headertitle?: string,
    pt_header?: string,
    pt_footertitle?: string,
    pt_footer?: string,
    webF7Format: number,
    showLoading: boolean,
    pt_negotiationzipvalidationstatus: number,
    removeButtonHidden: boolean,
    publicSectorDialog: boolean,
    federalSectorDialog: boolean,
    federalSubmissionURL?: string,
    publicSubmissionURL?: string
}

export default class F7GuestSubmission extends React.Component<F7ControlState> {
    _eSelection = new Selection({
        onSelectionChanged: () => this.setEmpAddressSelectedValue(this._eSelection.getSelection()),
    });

    _uSelection = new Selection({
        onSelectionChanged: () => this.setUnionAddressSelectedValue(this._uSelection.getSelection()),
    });

    state: F7ControlState = {
        formState: CommonModels.FormState.OnLoad,
        //dismissClonePrompt: false,
        //cloneModalHidden: true,
        //cloneModalLoading: false,
        //f7submissions: [],
        //selectionCount: 0,
        //selection: [],
        formSubmitted: false,
        casecategory: [],
        casesource: [],
        industry: [],
        unions: [],
        states: [],
        sectors: [],
        //bargainingunitsizes: [],
        errorMessages: [],
        //employerAddressSame: false,
        //unionAddressSame: false,
        dialogHidden: true,
        //dialogResetHidden: true,
        pt_notices: 1,
        pt_nreceiveddate: new Date(),
        pt_receiveddate: new Date(),
        pt_f7noticesubmissionformat: 206300000,
        pt_noticeunion_selectedItems: [],
        pt_noticeemployerstate_selectedItems: [],
        pt_nemployercontactstate_selectedItems: [],
        pt_noticeunionstate_selectedItems: [],
        pt_nunioncontactstate_selectedItems: [],
        pt_noticeaffectedstate_selectedItems: [],
        pt_noticenegotiationstate_selectedItems: [],
        pt_negotiationzipvalidationstatus: zipValidationStatusOptions.InvalidZip,
        pt_noticecasesource: null,
        pt_nsector: null,
        pt_noticecategory: null,
        pt_noticeexpirationdate: null,
        pt_noticereopenerdate: null,
        //filters: [],
        //filterYear: 25,
        //f7Filter: 25,
        //userFilters: [],
        //pt_nbargainingunitsizeText: null,

        addressSearchMinLength: 3,
        azMapsKey: 'EIBAsug5HXjYKUTGdubbqIxC7fR-lD9gg4k4HDDKLec',
        azMapsLanguage: 'en-US',
        azMapsCoutrySet: 'US',
        addresssGeocodeServiceUrlTemplate: 'https://atlas.microsoft.com/search/address/json?typeahead=true&api-version=1&subscription-key={key}&query={query}&language={language}&countrySet={countrySet}&view=Auto',
        searchAddresses: [],
        eCalloutVisible: false,
        uCalloutVisible: false,
        isLoaded: false,
        employerAddressSearchId: 'pt_noticeemployeraddressline1',
        unionAddressSearchId: 'pt_noticeunionaddressline1',
        isSuccessorContract: true,
        isContractReopener: false,
        pt_headertitle: null,
        pt_header: null,
        pt_footertitle: null,
        pt_footer: null,
        webF7Format: 692220000,
        showLoading: false,
        removeButtonHidden: true,
        publicSectorDialog: true,
        federalSectorDialog: true
    }


    public componentDidMount() {
        $('input[alt=zipmask]').mask('00000-0000', {
            placeholder: 'Enter 5 or 9 digit zip code'
        });
        $('input[alt=phonemask]').mask('(000) 000-0000', {
            placeholder: '(000) 000-0000'
        });

        ////$('input[alt=primaryFunctionMask]').mask('50 characters max', {
        ////    placeholder: '50 characters max'
        ////});

        //eventListener = EventBus.getInstance().register('F7Submission', (name: string) => {
        //    console.log("F7Submission.EventListener: " + name);
        //    switch (name) {
        //        case "ResetFormData":
        //            if (this.state.formState == CommonModels.FormState.SaveComplete) {
        //                this.resetFormData();
        //            }
        //            else {
        //                this.setState({ dialogResetHidden: false });
        //            }
        //            break;
        //    }
        //});

        switch (baseURL) {
            case "fmcsportal.azurewebsites.net":
                this.setState({ federalSubmissionURL: "/RequestLink?rt=d60b0ef1-03e1-ed11-a7c6-001dd8072455&s=a489df88-0339-e811-8126-1458d04dc8c8" });
                this.setState({ publicSubmissionURL: "/RequestLink?rt=d60b0ef1-03e1-ed11-a7c6-001dd8072455&s=15b7a10b-0102-ed11-bb3a-001dd80683d2" });

                break;

            case "fmcstestportal.azurewebsites.net":
                this.setState({ federalSubmissionURL: "/RequestLink?rt=d60b0ef1-03e1-ed11-a7c6-001dd8072455&s=a489df88-0339-e811-8126-1458d04dc8c8" });
                this.setState({ publicSubmissionURL: "/RequestLink?rt=d60b0ef1-03e1-ed11-a7c6-001dd8072455&s=15b7a10b-0102-ed11-bb3a-001dd80683d2" });

                break;

            default:
                this.setState({ federalSubmissionURL: "/RequestLink?rt=a75641e3-b4a0-ed11-aad0-001dd806a766&s=a489df88-0339-e811-8126-1458d04dc8c8" });
                this.setState({ publicSubmissionURL: "/RequestLink?rt=a75641e3-b4a0-ed11-aad0-001dd806a766&s=15b7a10b-0102-ed11-bb3a-001dd80683d2" });
        }

        fetch('sector')
            .then(response => response.json())
            .then(dataSectors => this.setState({ sectors: dataSectors, pt_nsectorlabel: "Private Sector", pt_nsector: dataSectors.filter(function (v: any, i: any) { return v.value == "Private Sector" })[0].key }));
        fetch('casecategory')
            .then(response => response.json())
            .then(dataCaseCategory => this.setState({ casecategory: dataCaseCategory, pt_noticecategorylabel: "Successor Contract", pt_noticecategory: dataCaseCategory.filter(function (v: any, i: any) { return v.value == "Successor Contract" })[0].key }));
        fetch('casesource?isRequestTypeStr=false')
            .then(response => response.json())
            .then(dataCaseSource => this.setState({ casesource: dataCaseSource }));
        fetch('industry')
            .then(response => response.json())
            .then(dataIndustry => this.setState({ industry: dataIndustry }));
        fetch('states')
            .then(response => response.json())
            .then(dataStates => this.setState({ states: dataStates }));
        fetch('unions')
            .then(response => response.json())
            .then(dataUnions => this.setState({ unions: dataUnions }));
        fetch('casetype')
            .then(response => response.json())
            .then(dataCaseType => this.setState({ formState: CommonModels.FormState.LoadComplete, pt_noticecasetype: dataCaseType.filter(function (v: any, i: any) { return v.value == "CBM" })[0].key }));
        this.getFormParameters();
        //this.getSecureData();
    }

    private getFormParameters() {
        const requestOptions = {
            method: 'GET'
        };
        fetch('PortalFormParameters?formType=' + this.state.webF7Format, requestOptions)
            .then(response => response.json())
            .then(portalParameters => this.loadPortalParameters(portalParameters))
            .then(() => this.setState({ showLoading: true }));
    }

    private loadPortalParameters(portalParameters) {
        this.state.pt_headertitle = portalParameters[0].headerTitle;
        this.state.pt_header = portalParameters[0].header;
        this.state.pt_footertitle = portalParameters[0].footerTitle;
        this.state.pt_footer = portalParameters[0].footer;
    }


    private getErrorMessage = (errorMessages: Array<CommonModels.KeyValuePair>, id: string): string => {
        let controlErrors: Array<CommonModels.KeyValuePair> = errorMessages.filter(function (v, i) { return v.key == id });
        if (controlErrors.length > 0) {
            return (controlErrors[0].value as Array<string>).join("\n");
        }
        return "";
    };

    private clearedErrorMessages = (field: string): Array<CommonModels.KeyValuePair> => {
        let _errorMessages = this.state.errorMessages as Array<CommonModels.KeyValuePair>;
        _errorMessages.forEach(a => { if (a.key == field) { a.value = []; } });
        return _errorMessages;
    }

    private onChangeField = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (event.currentTarget.id === "pt_noticenegotiationzip") {
            if (event.currentTarget.value !== null && (event.currentTarget.value.length === 5 || event.currentTarget.value.length === 9)) {
                fetch('zipcode?zip=' + event.currentTarget.value)
                    .then(response => response.json())
                    .then(dataZip => {
                        //console.log(dataZip);
                        if (dataZip[0] === true) {
                            this.setState({ pt_negotiationzipvalidationstatus: zipValidationStatusOptions.ValidZip });
                        }
                        else {
                            //Didn't find zip in CRM, Query AzureAPI to see if it's valid.
                            this.onExecuteValidateZip(this.state.pt_noticenegotiationzip, true);
                        }
                    });
            }
        }

        if (event.currentTarget.type == "number") {
            this.setState({ errorMessages: this.clearedErrorMessages(event.currentTarget.id), [event.currentTarget.id]: event.currentTarget.value.length == 0 ? null : parseInt(event.currentTarget.value) });
        }
        else {
            this.setState({ errorMessages: this.clearedErrorMessages(event.currentTarget.id), [event.currentTarget.id]: event.currentTarget.value });
        }
    }

    private configureSectorFields(optionText) {
        //logic for the notice category radio buttons
        switch (optionText) {
            case 'Successor Contract':
                this.setState({ isSuccessorContract: true, isContractReopener: false, pt_noticereopenerdate: null });
                break;
            case 'Contract Re-Opener':
                this.setState({ isContractReopener: true, isSuccessorContract: false });
                break;
            case 'Initial Contract':
                this.setState({ isContractReopener: false, isSuccessorContract: false, pt_noticeexpirationdate: null, pt_noticereopenerdate: null });
                break;
            default:
                break;
        }
    }


    private onChangeFieldChoiceSet = (field: string, ev?: React.FormEvent<HTMLInputElement | HTMLElement> | undefined, option?: IChoiceGroupOption | undefined): void => {
        this.setState({ errorMessages: this.clearedErrorMessages(field), [`${field}label`]: option?.text, [field]: option?.key });

        if (field == 'pt_noticecategory') {
            this.configureSectorFields(option.text);
        }

        if (field === 'pt_nsector') {
            //sector being changed

            if (option.text === 'Public Sector') {
                this.setState({ publicSectorDialog: false });
            }
            else if (option.text === 'Federal Sector') {
                this.setState({ federalSectorDialog: false });
            }
        }
    }

    private onChangeTagPickerState = (logicalName: string, items?: ITag[] | undefined, saveIdProperty?: boolean): void => {
        if (items == undefined || items?.length == 0) {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: undefined, [`${logicalName}_selectedItems`]: items });
            return;
        }
        let state = this.state.states.filter(function (value: CommonModels.State, index: number, arr) { return value.id == items[0].key })[0];
        if (saveIdProperty != undefined && saveIdProperty) {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: state.id, [`${logicalName}_selectedItems`]: items });
        }
        else {
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: state.abbreviation, [`${logicalName}_selectedItems`]: items });
        }
    }

    private onFilterChangedEmployerAddress = (newValue?: string | undefined) => {
        this.setState({ pt_noticeemployeraddressline1: newValue });
        if (newValue == undefined) {
            this.setState({ isLoaded: true, eCalloutVisible: false });
            return;
        }
        if (newValue.length < this.state.addressSearchMinLength) {
            return;
        }
        setTimeout(() => { this.onExecuteQueryEmployerAddress(newValue, true); }, 1000);
    }

    private onExecuteQueryEmployerAddress = (queryValue: string, isSearchAction: boolean) => {
        this.setState({ searchAddresses: [] });
        let requestUrl = this.state.addresssGeocodeServiceUrlTemplate.replace('{query}', encodeURIComponent(queryValue))
            .replace('{language}', this.state.azMapsLanguage)
            .replace('{countrySet}', this.state.azMapsCoutrySet)
            .replace('{key}', this.state.azMapsKey); //A comma seperate

        fetch(requestUrl)
            .then(res => res.json())
            .then(
                (data) => {
                    let addressResults: Array<any> = [];

                    if (this.state.searchAddresses.length > 0)
                        this.state.searchAddresses = [];

                    for (var i = 0; i < data.results.length; i++) {
                        this.state.searchAddresses.push(data.results[i].address)
                    }

                    if (isSearchAction) {
                        this.setState({ isLoaded: true, eCalloutVisible: true, addressResults: addressResults, response: JSON.stringify(data) });
                    } else if (!isSearchAction && addressResults.length > 0) {
                        this.setState({ address: addressResults[0] });//, this.renderMap);
                    }
                },
                (error) => {
                    this.setState({ isLoaded: true, error });
                }
            )
    }

    private onFilterChangedUnionAddress = (newValue?: string | undefined) => {
        this.setState({ pt_noticeunionaddressline1: newValue });
        if (newValue == undefined) {
            this.setState({ isLoaded: true, uCalloutVisible: false });
            return;
        }
        if (newValue.length < this.state.addressSearchMinLength) {
            return;
        }

        setTimeout(() => { this.onExecuteQueryUnionAddress(newValue, true); }, 1000);
    }

    private onExecuteQueryUnionAddress = (queryValue: string, isSearchAction: boolean) => {
        this.setState({ searchAddresses: [] });
        var requestUrl = this.state.addresssGeocodeServiceUrlTemplate.replace('{query}', encodeURIComponent(queryValue))
            .replace('{language}', this.state.azMapsLanguage)
            .replace('{countrySet}', this.state.azMapsCoutrySet)
            .replace('{key}', this.state.azMapsKey); //A comma seperate

        fetch(requestUrl)
            .then(res => res.json())
            .then(
                (data) => {
                    let addressResults: Array<any> = [];

                    if (this.state.searchAddresses.length > 0)
                        this.state.searchAddresses = [];

                    for (var i = 0; i < data.results.length; i++) {
                        this.state.searchAddresses.push(data.results[i].address)
                    }

                    if (isSearchAction) {
                        this.setState({ isLoaded: true, uCalloutVisible: true, addressResults: addressResults, response: JSON.stringify(data) });
                    } else if (!isSearchAction && addressResults.length > 0) {
                        this.setState({ address: addressResults[0] });//, this.renderMap);
                    }
                },
                (error) => {
                    this.setState({ isLoaded: true, error });
                }
            )
    }

    private setEmpAddressSelectedValue(newValue: any) {
        this.setState({ eCalloutVisible: false });//, address: newValue.length > 0 ? newValue[0] : undefined });        
        if (newValue.length > 0) {
            if (newValue[0].streetNumber != undefined && newValue[0].streetName != undefined) {
                this.setState({ pt_noticeemployeraddressline1: newValue[0].streetNumber + " " + newValue[0].streetName });
            } else if (newValue[0].streetName != undefined) {
                this.setState({ pt_noticeemployeraddressline1: newValue[0].streetName });
            }

            this.setState({ pt_noticeemployercity: newValue[0].localName });
            this.setState({ pt_noticeemployerzip: newValue[0].postalCode });

            let stateId = this.state.states.find(i => i.abbreviation === newValue[0].countrySubdivision).id;
            let stateITag: ITag = {
                name: newValue[0].countrySubdivision,
                key: stateId
            }

            const items: ITag[] = new Array();
            items.push(stateITag);
            this.onChangeTagPickerState("pt_noticeemployerstate", items);
        }
        if (this.state.controlCallback == undefined)
            return
    }

    private setUnionAddressSelectedValue(newValue: any) {

        this.setState({ uCalloutVisible: false });//, address: newValue.length > 0 ? newValue[0] : undefined });        
        if (newValue.length > 0) {

            if (newValue[0].streetNumber != undefined && newValue[0].streetName != undefined) {
                this.setState({ pt_noticeunionaddressline1: newValue[0].streetNumber + " " + newValue[0].streetName });
            } else if (newValue[0].streetName != undefined) {
                this.setState({ pt_noticeunionaddressline1: newValue[0].streetName });
            }

            this.setState({ pt_noticeunioncity: newValue[0].localName });
            this.setState({ pt_noticeunionzip: newValue[0].postalCode });

            let stateId = this.state.states.find(i => i.abbreviation === newValue[0].countrySubdivision).id;
            let stateITag: ITag = {
                name: newValue[0].countrySubdivision,
                key: stateId
            }

            const items: ITag[] = new Array();
            items.push(stateITag);
            this.onChangeTagPickerState("pt_noticeunionstate", items);
        }
        if (this.state.controlCallback == undefined)
            return
    }

    private onResolveSuggestionsUnion = (filterText: string, tagList: ITag[] | undefined): ITag[] => {
        if (filterText == undefined || filterText.trim().length == 0) return [];
        return this.state.unions.filter(keyValue => (keyValue.name != null && keyValue.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1) || (keyValue.acronym != null && keyValue.acronym.toLowerCase().indexOf(filterText.toLowerCase()) > -1)).map(item => { let unionSuggestion: ITag = { key: item.id, name: item.name }; return unionSuggestion; });
    };

    private onExecuteValidateZip = (zip: string, isSearchAction: boolean) => {
        let requestUrl = this.state.addresssGeocodeServiceUrlTemplate.replace('{query}', encodeURIComponent(zip))
            .replace('{language}', this.state.azMapsLanguage)
            .replace('{countrySet}', this.state.azMapsCoutrySet)
            .replace('{key}', this.state.azMapsKey); //A comma seperate

        fetch(requestUrl)
            .then(res => res.json())
            .then(
                (data) => {
                    debugger;
                    let foundGeography = false;
                    if (data.results.length != 0) {
                        for (var i = 0; i < data.results.length; i++) {
                            if (data.results[i].type === "Geography") {
                                foundGeography = true;
                            }
                        }
                    }
                    if (foundGeography) {
                        this.setState({ pt_negotiationzipvalidationstatus: zipValidationStatusOptions.MissinginCRM });
                    }
                    else
                        this.setState({ pt_negotiationzipvalidationstatus: zipValidationStatusOptions.InvalidZip });
                },
                (error) => {
                    this.setState({ isLoaded: true, error });
                }
            )
    }

    private onResolveSuggestionsState = (filterText: string, tagList: ITag[] | undefined): ITag[] => {
        if (filterText == undefined || filterText.trim().length == 0) return [];
        /*return this.state.states.filter(keyValue => (keyValue.name != null && keyValue.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1) || (keyValue.abbreviation != null && keyValue.abbreviation.toLowerCase().indexOf(filterText.toLowerCase()) > -1)).map(item => { let stateSuggestion: ITag = { key: item.id, name: item.abbreviation }; return stateSuggestion; });*/
        return this.state.states.filter(keyValue => (keyValue.abbreviation != null && keyValue.abbreviation.toLowerCase().indexOf(filterText.toLowerCase()) > -1)).map(item => { let stateSuggestion: ITag = { key: item.id, name: item.abbreviation }; return stateSuggestion; });
    };

    private onRenderSuggestionsItemState = (props: ITag, itemProps: ISuggestionItemProps<ITag>): JSX.Element => {
        let union = this.state.states.filter(function (value: CommonModels.State, index: number, arr) { return value.id == props.key })[0];
        return <div className={classNames.itemCell} data-is-focusable={false} style={{ width: "100%", alignContent: "left" }}>
            <div className={classNames.itemContent}>
                <div className={classNames.itemName}>{union.abbreviation}</div>
                {union.name}
            </div>
            <Icon className={classNames.chevron} iconName={'ChevronRight'} />
        </div>
    }

    private renderChoiceGroupOption = (data: Array<any>): IChoiceGroupOption[] => {
        let options: IChoiceGroupOption[] = [];
        data.forEach(a => { options.push({ key: a.key, text: a.value, styles: { choiceFieldWrapper: { display: 'inline-block', margin: '0 0 0 20px' } } }); });
        return options;
    }

    private renderDropdownOption = (keyField: string, valueField: string, data: Array<any>): IDropdownOption[] => {
        let options: IDropdownOption[] = [];
        data.forEach(a => { options.push({ key: a[keyField], text: a[valueField], data: a }); });
        return options;
    }

    private renderCategoryChoiceGroupOption = (data: Array<any>): IChoiceGroupOption[] => {
        let options: IChoiceGroupOption[] = [];

        data.forEach(a => {
            if (a.value === "Successor Contract") {
                options.push({
                    key: a.key, text: a.value, styles: { choiceFieldWrapper: { display: 'inline-block', margin: '0 0 0 20px' } },
                    onRenderField: (props, render) => {

                        return (
                            <StackItem>
                                {render!(props)} <br />
                                <i>Expiring existing contract</i>
                            </StackItem>
                        )
                    }
                });
            }

            else if (a.value === "Contract Re-Opener") {
                options.push({
                    key: a.key, text: a.value, styles: { choiceFieldWrapper: { display: 'inline-block', margin: '15px 0 0 20px' } },
                    onRenderField: (props, render) => {

                        return (
                            <StackItem>
                                {render!(props)} <br />
                                <i>Mid-term re-opener of existing contract</i>
                            </StackItem>
                        )
                    }
                });
            }
            else if (a.value === "Initial Contract") {
                options.push({
                    key: a.key, text: a.value, styles: { choiceFieldWrapper: { display: 'inline-block', margin: '15px 0 0 20px' } },
                    onRenderField: (props, render) => {
                        return (
                            <StackItem>
                                {render!(props)} <br />
                                <i>Initial or First contracts usually do not file. This may cause a duplication in the system since we are already notified by the NLRB.
                                    These cases automatically get assigned a mediator and you should be contacted shortly. If you need a mediator,
                                    email us at clientservices@fmcs.gov and indicate that your mediator request is related to an initial contract and who the involved parties are.</i>
                            </StackItem>
                        )
                    }
                });
            }
        });
        return options;
    }

    private onChangeDropdown = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined): void => {
        this.setState({ errorMessages: this.clearedErrorMessages((event.target as any).id), [(event.target as any).id]: option?.key });
        let fieldId = (event.target as any).id;
    };

    private onChangeDatePicker = (field: string, date: Date | null | undefined): void => {
        this.setState({ errorMessages: this.clearedErrorMessages(field), [field]: date });
    }

    private onChangeTagPickerUnion = (logicalName: string, items?: ITag[] | undefined): void => {
        if (items == undefined || items?.length == 0) {
            //clear the acronym field
            this.setState({ pt_nunionacronym: null });
            this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: undefined, [`${logicalName}_selectedItems`]: items });
            return;
        }

        //find the selected union from the list
        let selectedUnion = this.state.unions.filter(function (value: CommonModels.Union, index: number, arr) { return value.id == items[0].key })[0];

        //set the acronym field value
        this.setState({ pt_nunionacronym: selectedUnion.acronym });
        this.setState({ errorMessages: this.clearedErrorMessages(logicalName), [logicalName]: items[0].name, "pt_nunionid": items[0].key, [`${logicalName}_selectedItems`]: items });
    }

    private onRenderSuggestionsItemUnion = (props: ITag, itemProps: ISuggestionItemProps<ITag>): JSX.Element => {
        let union = this.state.unions.filter(function (value: CommonModels.Union, index: number, arr) { return value.id == props.key })[0];
        return <div className={classNames.itemCell} data-is-focusable={false} style={{ width: "100%", alignContent: "left" }}>
            <div className={classNames.itemContent}>
                <div className={classNames.itemName}>{union.name}</div>
                {union.acronym}
            </div>
            <Icon className={classNames.chevron} iconName={'ChevronRight'} />
        </div>
    }

    private onChangeFile = (event: any | undefined): void => {
        var removeBtn = document.getElementById("fileupload");
        if (event == undefined || event.currentTarget == undefined || event.currentTarget.files == undefined || event.currentTarget.files.length == 0) {
            this.setState({ removeButtonHidden: true });
            return;
        } else {
            this.setState({ attachment: event.currentTarget.files[0] });
            this.setState({ removeButtonHidden: false });
        }
    }

    private removeFileAttachment = (event: any | undefined): void => {
        document.getElementById("fileupload")["value"] = "";
        this.setState({ attachment: null });
        this.setState({ removeButtonHidden: true });
    }

    private addFieldRequirement = (fieldId: string, message: string): void => {
        let found: boolean;
        found = false;
        required.forEach(function (value) {
            if (value.key == fieldId) {
                found = true;
            }
        })
        if (!found) {
            required.push({ key: fieldId, value: message });
        }
    }

    private customRequirementRules = (): void => {

        //reset the requirement rules back to their original state
        let resetRequirementRules = [
            "pt_noticeexpirationdate",
            "pt_noticereopenerdate"
            //"pt_noticebu"
        ];

        invalid = [];
        required = required.filter(function (value: CommonModels.KeyValuePair, index: number, arr) {
            return (resetRequirementRules.filter(f => f === value.key).length === 0);
        });

        if (this.state.pt_noticecategorylabel === "Successor Contract") {
            //required.push({ key: "pt_noticeexpirationdate", value: "CBA and Bargaining Unit Information - Contract Expiration Date is required" });
            //   this.addFieldRequirement("pt_noticeexpirationdate", "CBA and Bargaining Unit Information - Contract Expiration Date is required");
        }
        else if (this.state.pt_noticecategorylabel === "Contract Re-Opener") {
            //required.push({ key: "pt_noticeexpirationdate", value: "CBA and Bargaining Unit Information - Contract Expiration Date is required" });
            //    this.addFieldRequirement("pt_noticeexpirationdate", "CBA and Bargaining Unit Information - Contract Expiration Date is required");
            //required.push({ key: "pt_noticereopenerdate", value: "CBA and Bargaining Unit Information - Contract Reopener Date is required" });
            //    this.addFieldRequirement("pt_noticereopenerdate", "CBA and Bargaining Unit Information - Contract Reopener Date is required");
        }

        //validate emails
        let validateEmail: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployeremail", value: "Employer Chief Negotiator or Labor Relations Director - Business Email is invalid" },
            { key: "pt_noticeunionemail", value: "Union Chief Negotiator or Business Agent - Business Email is invalid" },
            { key: "pt_nfileremail", value: "Official Filer - Business Email is invalid" },
            { key: "pt_noticeemployeremail_confirm", value: "Employer Chief Negotiator or Labor Relations Director - Confirmation Email is invalid" },
            { key: "pt_noticeunionemail_confirm", value: "Union Chief Negotiator or Business Agent - Confirmation Email is invalid" },
            { key: "pt_nfileremail_confirm", value: "Official Filer - Confirmation Email is invalid" },
        ];
        validateEmail.forEach(a => {
            if (this.state[a.key] == null) return;
            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(this.state[a.key].trim()))) {
                invalid.push({ key: a.key, value: a.value });
            }
        });
        if (this.state.pt_noticeemployeremail != null && this.state.pt_noticeemployeremail_confirm != null && this.state.pt_noticeemployeremail.trim() != this.state.pt_noticeemployeremail_confirm.trim()) {
            invalid.push({ key: "pt_noticeemployeremail_confirm", value: "Employer Chief Negotiator or Labor Relations Director - Confirmation Email must match" });
        }
        if (this.state.pt_noticeunionemail != null && this.state.pt_noticeunionemail_confirm != null && this.state.pt_noticeunionemail.trim() != this.state.pt_noticeunionemail_confirm.trim()) {
            invalid.push({ key: "pt_noticeunionemail_confirm", value: "Union Chief Negotiator or Business Agent - Confirmation Email must match" });
        }

        if (this.state.pt_nfileremail != null && this.state.pt_nfileremail_confirm != null && this.state.pt_nfileremail.trim() != this.state.pt_nfileremail_confirm.trim()) {
            invalid.push({ key: "pt_nfileremail_confirm", value: "Official Filer - Confirmation Email must match" });
        }

        //make sure the employer & union emails aren't the same
        if (this.state.pt_noticeemployeremail !== undefined && this.state.pt_noticeunionemail !== undefined && this.state.pt_noticeemployeremail === this.state.pt_noticeunionemail) {
            invalid.push({ key: "pt_noticeemployeremail", value: "Employer & Union Negotiator's email can't be the same" });
            invalid.push({ key: "pt_noticeunionemail", value: "Union & Employer Negotiator's email can't be the same" });
        }

        //        console.log(this.state.attachment);
        if (this.state.attachment != undefined && this.state.attachment != null && this.state.attachment.name != undefined && this.state.attachment.name != null && this.state.attachment.name.indexOf(".csv") == -1 && this.state.attachment.name.indexOf(".pdf") == -1) {
            invalid.push({ key: "attachment", value: "The attached additional notices must be of file type 'CSV' or 'PDF'" });
        }

        //validate phones
        let validatePhone: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployerphone", value: "Employer Rep - Phone is invalid" },
            { key: "pt_noticeunionphone", value: "Union Rep - Phone is invalid" },
            { key: "pt_nfilerphone", value: "Official Filer - Phone is invalid" }
        ];
        validatePhone.forEach(a => {
            if (this.state[a.key] == null) return;
            var numericPhone = this.state[a.key].replace(/\D/g, '');
            if (numericPhone.length > 0 && numericPhone.length != 10) {
                invalid.push({ key: a.key, value: a.value });
            }
        });

        //validate area code
        let validateAreaCode: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployerphone", value: "Employer Rep - Phone Area Code is invalid" },
            { key: "pt_noticeunionphone", value: "Union Rep - Phone Area Code is invalid" },
            { key: "pt_nfilerphone", value: "Official Filer - Phone Area Code is invalid" }
        ];
        validateAreaCode.forEach(a => {
            if (this.state[a.key] == null) return;
            var numericPhone = this.state[a.key].replace(/\D/g, '');
            if (numericPhone.length > 0) {
                var areaCode = numericPhone.substring(0, 3);
                var areaCodeNumber: number = +areaCode;
                if (numericPhone.length > 0 && areaCodeNumber < 201) {
                    invalid.push({ key: a.key, value: a.value });
                }
            }
        });

        //make sure the employer & union phones aren't the same
        if (this.state.pt_noticeunionphone !== undefined && this.state.pt_noticeemployerphone !== undefined && this.state.pt_noticeemployerphone === this.state.pt_noticeunionphone) {
            invalid.push({ key: "pt_noticeemployerphone", value: "Employer & Union Negotiator's Phone can't be the same" });
            invalid.push({ key: "pt_noticeunionphone", value: "Union & Employer Negotiator's Phone can't be the same" });
        }

        //validate zip
        let validateZip: Array<CommonModels.KeyValuePair> = [
            { key: "pt_noticeemployerzip", value: "Employer / Agency - Zip is invalid" },
            { key: "pt_nemployercontactzip", value: "Employer Rep - Zip is invalid" },
            { key: "pt_noticeunionzip", value: "Union - Zip is invalid" },
            { key: "pt_nunioncontactzip", value: "Union Rep - Zip is invalid" },
            { key: "pt_noticenegotiationzip", value: "Location of Negotiation - Zip is invalid" },
        ];
        validateZip.forEach(a => {
            if (this.state[a.key] == null) return;
            if (this.state[a.key].charAt(this.state[a.key].length - 1) === "-") {
                this.state[a.key] = this.state[a.key].substring(0, this.state[a.key].length - 1);
            }
            var zip = this.state[a.key].replace(/\D/g, '');
            if (zip.length > 0 && (zip.length != 5 && zip.length != 9)) {
                invalid.push({ key: a.key, value: a.value });
            }
        });

        // console.log("zip " + this.state.pt_noticenegotiationzip);
        if (this.state.pt_noticenegotiationzip !== undefined && this.state.pt_negotiationzipvalidationstatus === zipValidationStatusOptions.InvalidZip) {

            //if (!invalid.find({ key: "pt_noticenegotiationzip", value: "Location of Negotiation - Zip is invalid" })) {
            if (invalid.find(({ key }) => key === "pt_noticenegotiationzip") === undefined) {
                //   console.log("adding our message");
                invalid.push({ key: "pt_noticenegotiationzip", value: "Location of Negotiation - Zip is invalid" });
            }
        }

        if (this.state.pt_noticeunion == null || this.state.pt_noticeunion.trim().length == 0) {
            invalid.push({ key: "pt_noticeunion", value: "Union Information - Union Full Name is required" });
        }
        //validate custom union

        if (this.state.pt_noticeunion_selectedItems.length > 0 && this.state.pt_noticeunion_selectedItems[0].name == "Other") {
            if (this.state.pt_noticeunionother == null || this.state.pt_noticeunionother.trim().length == 0) {
                invalid.push({ key: "pt_noticeunionother", value: "Union - Other Union Name is required" });
            }

            if (this.state.pt_nunionacronym == null || this.state.pt_nunionacronym.trim().length == 0) {
                invalid.push({ key: "pt_nunionacronym", value: "Union - Union ACRONYM is required" });
            }
        }


        if (this.state.pt_noticebu === null)
            this.addFieldRequirement("pt_noticebu", "CBA and Bargaining Unit Information - Number of Bargaining Unit Employees Covered by the Contract is Required");
        else {
            // if (this.state.pt_nbargainingunitsizeText = "1500+") {
            if (!Number.isInteger(this.state.pt_noticebu)) {
                invalid.push({ key: "pt_noticebu", value: "CBA and Bargaining Unit Information - Number of Bargaining Unit Employees Covered by the Contract - Must be a whole number greater than 1" });
            }
            else if (this.state.pt_noticebu < 2) {
                invalid.push({ key: "pt_noticebu", value: "CBA and Bargaining Unit Information - Number of Bargaining Unit Employees Covered by the Contract - Must be greater than 1" });
            }
            //}
        }
    }

    private onSubmitForm = (event: any): void => {
        let newStateData: any = {};
        newStateData.pt_noticeemployercontact = `${this.state.pt_nemployercontactfirstname} ${this.state.pt_nemployercontactlastname}`;
        newStateData.pt_noticeunioncontact = `${this.state.pt_nunioncontactfirstname} ${this.state.pt_nunioncontactlastname}`;
        this.customRequirementRules();

        if (this.state.pt_noticeunion_selectedItems.length > 0 && this.state.pt_noticeunion_selectedItems[0].name == "Other") {
            newStateData.pt_noticeunion = this.state.pt_noticeunionother;
        }

        this.setState(newStateData, function () {
            let _errorMessages: Array<CommonModels.KeyValuePair> = [];

            invalid.forEach(a => {
                _errorMessages.push({ key: a.key, value: [a.value] });
            });

            required.forEach(a => {
                console.log(a.key);
                if (!this.state[a.key]) {
                    _errorMessages.push({ key: a.key, value: [a.value] })
                }
            });

            if (_errorMessages.length > 0) {
                this.setState({ formSubmitted: true, dialogHidden: false, errorMessages: _errorMessages });
                return;
            }

            this.setState({ formState: CommonModels.FormState.OnSave, formSubmitted: true });
            this.submitData();
        });
    }

    private async submitData() {
        const token = await authService.getAccessToken();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify(this.state)
        };

        fetch('F7PublicSubmissions', requestOptions)
            .then(response => response.json())
            .then(f7recordResponse => this.setState({ formState: CommonModels.FormState.SaveComplete, f7record: f7recordResponse }, () => this.submitAnnotation(f7recordResponse.id)));
    }

    private async submitAnnotation(id: string) {
        if (!this.state.attachment) return;

        let formData: FormData = new FormData();
        formData.append('Id', id);
        formData.append('LogicalName', "pt_fmcscase");
        formData.append('FormFile', this.state.attachment);
        const token = await authService.getAccessToken();
        const requestOptions = {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
        };
        fetch('AnnotationsPublic', requestOptions)
            .then(response => response.text())
            .then((responseText) => this.setState({ additionalNoticesId: responseText.replace(/"/g, '') }));
    }

    private resetFormData = () => {
        this.setState({ showLoading: true });
        let ignoreFields: Array<string> = ["pt_f7noticesubmissionformat", "pt_nreceiveddate", "pt_receiveddate", "pt_notices", /*"pt_nsector", "pt_nsectorlabel",*/ "pt_noticecasetype", "pt_nfilerfirstname", "pt_nfilerlastname", "pt_nfilertitle", "pt_nfileremail", "pt_fileremail_confirm", "pt_nfilerphone", "pt_nfilerphoneext"];
        let localState = this.state
        this.getFormParameters();
        this.setState({ showLoading: false });
        // localState.dialogResetHidden = true;
        localState.errorMessages = [];
        localState.formState = CommonModels.FormState.LoadComplete;
        for (var p in localState) {
            //  console.log(p);
            //  console.log(typeof localState[p]);
            if (p.indexOf("pt_") > -1 && !ignoreFields.includes(p)) {
                if (typeof localState[p] === 'string') {
                    localState[p] = '';
                }
                else if (typeof localState[p] === 'number') {
                    localState[p] = 0;
                }
                else if (typeof localState[p] === 'boolean') {
                    localState[p] = false;
                }
                else if (localState[p] instanceof Date) {
                    localState[p] = null;
                }
                else if (p.indexOf("_selectedItems") > -1) {
                    localState[p] = [];
                }
                else {
                    console.log(typeof localState[p]);
                }
            }
        }
        document.getElementById("fileupload")["value"] = "";
        localState.attachment = null;
        localState.additionalNoticesId = null;
        localState.removeButtonHidden = true;

        localState.pt_noticeexpirationdate = null;
        localState.pt_noticereopenerdate = null;
        localState.pt_noticebu = null;
        localState.formSubmitted = false;
        localState.showLoading = false;

        localState.pt_nsector = this.state.sectors.filter(function (v: any, i: any) { return v.value == "Private Sector" })[0].key;
        localState.pt_nsectorlabel = "Private Sector";

        localState.pt_noticecategory = this.state.casecategory.filter(function (v: any, i: any) { return v.value == "Successor Contract" })[0].key;
        localState.pt_noticecategorylabel = "Successor Contract";

        this.setState(localState);

        //clear the bu from the form UI; even though it's not in the state object anymore [bug in control]
        $('#pt_noticebu').val('');
    }

    public render() {
        return (
            <Stack>
                <StackItem style={{ display: this.state.formState == CommonModels.FormState.OnLoad || this.state.formState == CommonModels.FormState.LoadComplete ? "block" : "none" }}>
                    {/*Instructions / Header */}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        {/*                        <Text variant={"xLarge" as ITextProps['variant']}>F-7 Notice to FMCS of Upcoming Collective Bargaining</Text>*/}
                        <Text variant={"xLarge" as ITextProps['variant']}>{<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_headertitle }}></div>}</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem hidden={this.state.showLoading}>
                                <Spinner label="Loading..." ariaLive="assertive" labelPosition="right" />
                            </StackItem>
                            <StackItem>
                                {/*<Text>{this.state.pt_header}</Text>*/}

                                {<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_header }}></div>}
                            </StackItem>
                        </Stack>
                    </div>

                    {/*Notice Background*/}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Stack>
                            <StackItem>
                                <Text variant={"xLarge" as ITextProps['variant']}>Notice Background</Text>
                                <ChoiceGroup id="pt_noticecasesource" selectedKey={this.state.pt_noticecasesource} label="This notice is filed by the" styles={{ flexContainer: { display: "flex" } }} options={this.renderChoiceGroupOption(this.state.casesource)} onChange={(ev?: React.FormEvent<HTMLInputElement | HTMLElement> | undefined, option?: IChoiceGroupOption | undefined) => this.onChangeFieldChoiceSet("pt_noticecasesource", ev, option)} required />
                                <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "11px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticecasesource").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticecasesource")}</div>
                            </StackItem>

                        </Stack>
                    </div>

                    {/*Employer Information*/}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Employer Information</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <TextField label="Organization Name" id="pt_noticeemployer" value={this.state.pt_noticeemployer} maxLength={100} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployer")} required />
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Address Line 1" id="pt_noticeemployeraddressline1" value={this.state.pt_noticeemployeraddressline1}
                                            autoComplete="off"
                                            onChange={(event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => this.onFilterChangedEmployerAddress(newValue)}
                                            maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeraddressline1")} required />
                                    </StackItem>
                                    {this.state.eCalloutVisible && (
                                        <Callout
                                            styles={{ root: { width: "50%", maxWidth: "80%", padding: "5px 5px", backgroundColor: "white" } }}
                                            isBeakVisible={false}
                                            gapSpace={0}
                                            target={`#${this.state.employerAddressSearchId}`}
                                            onDismiss={e => this.setState({ eCalloutVisible: false })}
                                            directionalHint={DirectionalHint.bottomLeftEdge}
                                            role="alertdialog"
                                            setInitialFocus={true}>
                                            <DetailsList
                                                //styles={{ root: { width: "150", padding: "3px 3px" } }}
                                                items={this.state.searchAddresses}
                                                data-is-focusable={true}
                                                compact={true}
                                                columns={addressColumns}
                                                setKey="EmployerAddressSuggestions"
                                                layoutMode={DetailsListLayoutMode.justified}
                                                constrainMode={ConstrainMode.unconstrained}
                                                selectionMode={SelectionMode.single}
                                                selection={this._eSelection}
                                                //selectionPreservedOnEmptyClick={true}
                                                isHeaderVisible={false}
                                                onShouldVirtualize={() => false} />
                                        </Callout>
                                    )}
                                    <StackItem grow>
                                        <TextField label="Address Line 2" id="pt_noticeemployeraddressline2" name="pt_noticeemployeraddressline2" value={this.state.pt_noticeemployeraddressline2} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeraddressline2")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="City" id="pt_noticeemployercity" value={this.state.pt_noticeemployercity} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployercity")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <Label>State <span style={{ color: "rgb(164, 38, 44)" }}>*</span></Label>
                                        <TagPicker itemLimit={1} selectedItems={this.state.pt_noticeemployerstate_selectedItems} styles={{ input: this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerstate").length > 0 ? { borderColor: "rgb(164, 38, 44)", border: "solid 1px" } : {} }}
                                            removeButtonAriaLabel="Remove"
                                            pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                            onResolveSuggestions={this.onResolveSuggestionsState}
                                            onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerState("pt_noticeemployerstate", items) }}
                                            onRenderSuggestionsItem={this.onRenderSuggestionsItemState}
                                            getTextFromItem={(item: ITag) => item.name}
                                            pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested States', noResultsFoundText: 'No states found' }}
                                            inputProps={{
                                                'aria-label': "Type state or abbreviation",
                                                placeholder: "Type state or abbreviation",
                                                autoComplete: "none"
                                            }}
                                        />
                                        <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "12px", height: "23px", lineHeight: "18px", paddingTop: "5px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerstate").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerstate")}</div>
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Zip Code" alt="zipmask" id="pt_noticeemployerzip" value={this.state.pt_noticeemployerzip} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerzip")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <TextField label="Employer Web Site" id="pt_nemployerwebsite" value={this.state.pt_nemployerwebsite} maxLength={150} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployerwebsite")} />
                            </StackItem>
                            <StackItem>
                                <Dropdown id="pt_noticeindustry" selectedKey={this.state.pt_noticeindustry} label="Employer Industry or Work Activity" options={this.renderDropdownOption("key", "value", this.state.industry)} onChange={this.onChangeDropdown} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeindustry")} required />
                            </StackItem>
                            <StackItem>
                                <ChoiceGroup id="pt_nsector" selectedKey={this.state.pt_nsector} label="Employer Work Sector" styles={{ flexContainer: { display: "flex" } }} options={this.renderChoiceGroupOption(this.state.sectors)} onChange={(ev?: React.FormEvent<HTMLInputElement | HTMLElement> | undefined, option?: IChoiceGroupOption | undefined) => this.onChangeFieldChoiceSet("pt_nsector", ev, option)} required />
                                <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "11px", display: this.getErrorMessage(this.state.errorMessages, "pt_nsector").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_nsector")}</div>
                            </StackItem>
                            <StackItem>
                                &nbsp;
                            </StackItem>

                            <Text variant={"large" as ITextProps['variant']}>Employer Chief Negotiator or Labor Relations Director</Text>
                            <Separator alignContent="start"></Separator>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="First Name" id="pt_nemployercontactfirstname" value={this.state.pt_nemployercontactfirstname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployercontactfirstname")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Last Name" id="pt_nemployercontactlastname" value={this.state.pt_nemployercontactlastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployercontactlastname")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Business Email" id="pt_noticeemployeremail" value={this.state.pt_noticeemployeremail} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeremail")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Confirm Email" id="pt_noticeemployeremail_confirm" value={this.state.pt_noticeemployeremail_confirm} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployeremail_confirm")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField id="pt_noticeemployerphone" alt="phonemask" value={this.state.pt_noticeemployerphone} label="Primary Phone" onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeemployerphone")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Ext." id="pt_nemployerphoneext" value={this.state.pt_nemployerphoneext} onChange={this.onChangeField} maxLength={10} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nemployerphoneext")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>

                            <StackItem>
                                <hr />
                            </StackItem>
                        </Stack>

                    </div>

                    {/*CBA & Bargaining Unit Info*/}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>CBA and Bargaining Unit Information</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <ChoiceGroup id="pt_noticecategory" selectedKey={this.state.pt_noticecategory} label="Type of Upcoming Negotiation" styles={{ flexContainer: { display: "inline-block" } }} options={this.renderCategoryChoiceGroupOption(this.state.casecategory)} onChange={(ev?: React.FormEvent<HTMLInputElement | HTMLElement> | undefined, option?: IChoiceGroupOption | undefined) => this.onChangeFieldChoiceSet("pt_noticecategory", ev, option)} required />
                                <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "11px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticecategory").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticecategory")}</div>
                            </StackItem>
                            <StackItem>&nbsp;</StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow style={{ display: this.state.isSuccessorContract || this.state.isContractReopener ? "block" : "none" }}>
                                        <Label required>Contract Expiration Date</Label>
                                        <DatePicker id="pt_noticeexpirationdate" value={this.state.pt_noticeexpirationdate} firstDayOfWeek={DayOfWeek.Sunday} placeholder="Select a date..." ariaLabel="Select a date" onSelectDate={e => this.onChangeDatePicker("pt_noticeexpirationdate", e)} formatDate={(date?: Date): string => { return !date ? '' : (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear(); }} />
                                    </StackItem>
                                    <StackItem grow>
                                        <Label required style={{ display: this.state.isContractReopener ? "block" : "none" }}>Contract Reopen Date</Label>
                                        <DatePicker style={{ display: this.state.isContractReopener ? "block" : "none" }} id="pt_noticereopenerdate" value={this.state.pt_noticereopenerdate} firstDayOfWeek={DayOfWeek.Sunday} placeholder="Select a date..." ariaLabel="Select a date" onSelectDate={e => this.onChangeDatePicker("pt_noticereopenerdate", e)} formatDate={(date?: Date): string => { return !date ? '' : (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear(); }} />
                                    </StackItem>
                                    <StackItem grow style={{ display: this.state.pt_noticecategorylabel === "Initial Contract" ? "none" : "block", visibility: "hidden" }}>
                                        <TextField label="Placeholder" />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <div>
                                            <Label required>Estimated Bargaining Unit Size</Label>
                                            <input type="number" id="pt_noticebu" value={this.state.pt_noticebu} onChange={this.onChangeField} maxLength={6} placeholder="Enter a number" style={{ width: "100%" }} required />
                                            <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "11px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticebu").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticebu")}</div>
                                        </div>
                                    </StackItem>
                                </Stack>

                                <StackItem>
                                    &nbsp;
                                </StackItem>
                            </StackItem>

                            <Text variant={"large" as ITextProps['variant']}>Location of Negotiation</Text>
                            <Separator alignContent="start"></Separator>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="City" id="pt_noticenegotiationcity" value={this.state.pt_noticenegotiationcity} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationcity")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <Label>State <span style={{ color: "rgb(164, 38, 44)" }}>*</span></Label>
                                        <TagPicker itemLimit={1} selectedItems={this.state.pt_noticenegotiationstate_selectedItems} styles={{ input: this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationstate").length > 0 ? { borderColor: "rgb(164, 38, 44)", border: "solid 1px" } : {} }}
                                            removeButtonAriaLabel="Remove"
                                            pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                            onResolveSuggestions={this.onResolveSuggestionsState}
                                            onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerState("pt_noticenegotiationstate", items, true) }}
                                            onRenderSuggestionsItem={this.onRenderSuggestionsItemState}
                                            getTextFromItem={(item: ITag) => item.name}
                                            pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested States', noResultsFoundText: 'No states found' }}
                                            inputProps={{
                                                'aria-label': 'Type state or abbreviation',
                                                placeholder: 'Type state or abbreviation',
                                                autoComplete: "none"
                                            }}
                                        />
                                        <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "12px", height: "23px", lineHeight: "18px", paddingTop: "5px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationstate").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationstate")}</div>
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Zip Code" alt="zipmask" id="pt_noticenegotiationzip" value={this.state.pt_noticenegotiationzip} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticenegotiationzip")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </div>

                    {/*Union Block*/}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Stack>
                            <StackItem>
                                <Text variant={"xLarge" as ITextProps['variant']}>Union Information</Text>
                                <Separator alignContent="start"></Separator>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <Label>Union Full Name <span style={{ color: "rgb(164, 38, 44)" }}>*</span> (you may search for the union acronym or by part of the union name)</Label>
                                        <TagPicker itemLimit={1} selectedItems={this.state.pt_noticeunion_selectedItems} styles={{ input: this.getErrorMessage(this.state.errorMessages, "pt_noticeunion").length > 0 ? { borderColor: "rgb(164, 38, 44)", border: "solid 1px" } : {} }}
                                            removeButtonAriaLabel="Remove"
                                            pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                            onResolveSuggestions={this.onResolveSuggestionsUnion}
                                            onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerUnion("pt_noticeunion", items) }}
                                            onRenderSuggestionsItem={this.onRenderSuggestionsItemUnion}
                                            getTextFromItem={(item: ITag) => item.name}
                                            pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested Unions', noResultsFoundText: 'No unions found' }}
                                            inputProps={{
                                                'aria-label': 'Type to select your Union or type Other to enter if not found',
                                                placeholder: 'Type to select your Union or type Other to enter if not found',
                                                autoComplete: "none"
                                            }}
                                        />
                                        <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "12px", height: "23px", lineHeight: "18px", paddingTop: "5px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticeunion").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticeunion")}</div>
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem style={{ display: this.state.pt_noticeunion_selectedItems.length > 0 && this.state.pt_noticeunion_selectedItems[0].name == "Other" ? "block" : "none" }}>
                                <TextField label="Other Union Name" id="pt_noticeunionother" value={this.state.pt_noticeunionother} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionother")} required />
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem style={{ display: this.state.pt_noticeunion_selectedItems.length > 0 && this.state.pt_noticeunion_selectedItems[0].name == "Other" ? "block" : "none" }} grow>
                                        <TextField label="Union ACRONYM (i.e. SEIU)" id="pt_nunionacronym" value={this.state.pt_nunionacronym} onChange={this.onChangeField} maxLength={51} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nunionacronym")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Union Unit Number (enter in the District, Lodge, Chapter, Local etc.; for example, District Council 25, Local 102)" id="pt_noticeunionnumber" value={this.state.pt_noticeunionnumber} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionnumber")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>

                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Address Line 1" id="pt_noticeunionaddressline1" value={this.state.pt_noticeunionaddressline1}
                                            autoComplete="off"
                                            onChange={(event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => this.onFilterChangedUnionAddress(newValue)}
                                            maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionaddressline1")} required />
                                    </StackItem>
                                    {this.state.uCalloutVisible && (
                                        <Callout
                                            styles={{ root: { width: "50%", maxWidth: "80%", padding: "5px 5px", backgroundColor: "white" } }}
                                            isBeakVisible={false}
                                            gapSpace={0}
                                            target={`#${this.state.unionAddressSearchId}`}
                                            onDismiss={e => this.setState({ uCalloutVisible: false })}
                                            directionalHint={DirectionalHint.bottomLeftEdge}
                                            role="alertdialog"
                                            setInitialFocus={true}>
                                            <DetailsList
                                                items={this.state.searchAddresses}
                                                compact={true}
                                                columns={addressColumns}
                                                setKey="UnionAddressSuggestions"
                                                layoutMode={DetailsListLayoutMode.justified}
                                                constrainMode={ConstrainMode.unconstrained}
                                                selectionMode={SelectionMode.single}
                                                selection={this._uSelection}
                                                isHeaderVisible={false}
                                                onShouldVirtualize={() => true}
                                            />
                                        </Callout>
                                    )}

                                    <StackItem grow>
                                        <TextField label="Address Line 2" id="pt_noticeunionaddressline2" value={this.state.pt_noticeunionaddressline2} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionaddressline2")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="City" id="pt_noticeunioncity" value={this.state.pt_noticeunioncity} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunioncity")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <Label>State <span style={{ color: "rgb(164, 38, 44)" }}>*</span></Label>
                                        <TagPicker itemLimit={1} selectedItems={this.state.pt_noticeunionstate_selectedItems} styles={{ input: this.getErrorMessage(this.state.errorMessages, "pt_noticeunionstate").length > 0 ? { borderColor: "rgb(164, 38, 44)", border: "solid 1px" } : {} }}
                                            removeButtonAriaLabel="Remove"
                                            pickerCalloutProps={{ doNotLayer: true }} //keep this for accessibility
                                            onResolveSuggestions={this.onResolveSuggestionsState}
                                            onChange={(items?: ITag[] | undefined) => { this.onChangeTagPickerState("pt_noticeunionstate", items) }}
                                            onRenderSuggestionsItem={this.onRenderSuggestionsItemState}
                                            getTextFromItem={(item: ITag) => item.name}
                                            pickerSuggestionsProps={{ suggestionsHeaderText: 'Suggested States', noResultsFoundText: 'No states found' }}
                                            inputProps={{
                                                'aria-label': 'Type state or abbreviation',
                                                placeholder: 'Type state or abbreviation',
                                                autoComplete: "none"
                                            }}
                                        />
                                        <div role="alert" className="errorMessage" style={{ color: "rgb(164, 38, 44)", fontSize: "12px", height: "23px", lineHeight: "18px", paddingTop: "5px", display: this.getErrorMessage(this.state.errorMessages, "pt_noticeunionstate").length > 0 ? "block" : "none" }}>{this.getErrorMessage(this.state.errorMessages, "pt_noticeunionstate")}</div>
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Zip Code" alt="zipmask" id="pt_noticeunionzip" value={this.state.pt_noticeunionzip} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionzip")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Primary Function of Bargaining Unit Employees (Nurses, Janitors, Clerks, Bldg. Engineers, etc.)" id="pt_nprimaryfunctionofbargainingunitemployees" value={this.state.pt_nprimaryfunctionofbargainingunitemployees} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nprimaryfunctionofbargainingunitemployees")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                &nbsp;
                            </StackItem>
                        </Stack>
                        <Text variant={"large" as ITextProps['variant']}>Union Chief Negotiator or Business Agent</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="First Name" id="pt_nunioncontactfirstname" value={this.state.pt_nunioncontactfirstname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nunioncontactfirstname")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Last Name" id="pt_nunioncontactlastname" value={this.state.pt_nunioncontactlastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nunioncontactlastname")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Business Email" id="pt_noticeunionemail" value={this.state.pt_noticeunionemail} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionemail")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Confirm Email" id="pt_noticeunionemail_confirm" value={this.state.pt_noticeunionemail_confirm} onChange={this.onChangeField} maxLength={100} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionemail_confirm")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Primary Phone" alt="phonemask" id="pt_noticeunionphone" value={this.state.pt_noticeunionphone} onChange={this.onChangeField} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_noticeunionphone")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Ext" id="pt_nunioncontactphoneext" value={this.state.pt_nunioncontactphoneext} onChange={this.onChangeField} maxLength={10} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nunioncontactphoneext")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </div>

                    {/* Offical Filing Block*/}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Official Filing This Notice:</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="First Name" id="pt_nfilerfirstname" value={this.state.pt_nfilerfirstname} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfilerfirstname")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Last Name" id="pt_nfilerlastname" value={this.state.pt_nfilerlastname} onChange={this.onChangeField} maxLength={25} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfilerlastname")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Title" id="pt_nfilertitle" value={this.state.pt_nfilertitle} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfilertitle")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Business Email" id="pt_nfileremail" value={this.state.pt_nfileremail} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfileremail")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Confirm Email" id="pt_nfileremail_confirm" value={this.state.pt_nfileremail_confirm} onChange={this.onChangeField} maxLength={50} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfileremail")} required />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal wrap tokens={wrapTokens}>
                                    <StackItem grow>
                                        <TextField label="Primary Phone" alt="phonemask" id="pt_nfilerphone" value={this.state.pt_nfilerphone} onChange={this.onChangeField} maxLength={20} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfilerphone")} required />
                                    </StackItem>
                                    <StackItem grow>
                                        <TextField label="Ext." id="pt_nfilerphoneext" value={this.state.pt_nfilerphoneext} onChange={this.onChangeField} maxLength={20} errorMessage={this.getErrorMessage(this.state.errorMessages, "pt_nfilerphoneext")} />
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </div>

                    {/* Attachment Additional F7 Notices*/}
                    {/*<div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>*/}
                    {/*    <Text variant={"xLarge" as ITextProps['variant']}>Attachment</Text>*/}
                    {/*    <Separator alignContent="start"></Separator>*/}
                    {/*    <Stack>*/}
                    {/*        <StackItem>*/}
                    {/*            <p>*/}
                    {/*                To submit more than one notice, download the attached template <strong><a href="/template.csv" target="_blank">here</a></strong> and complete all fields in each row for each additional notice.*/}
                    {/*                Once completed, save the form as a .csv file and upload the completed form <strong>by clicking the “Choose File” button below</strong>.*/}
                    {/*            </p>*/}
                    {/*            <span>*/}
                    {/*                <strong>NOTE:</strong>*/}
                    {/*                <ol>*/}
                    {/*                    <li>Don’t change the headers in the .csv template, or the subsequent file to deliver might not create (the pdf).</li>*/}
                    {/*                    <li>The upload will accept both a .csv according to the template provided…or a PDF file if you have a packet of letters.</li>*/}
                    {/*                </ol>*/}
                    {/*            </span>*/}
                    {/*        </StackItem>*/}
                    {/*        <StackItem>*/}
                    {/*            <input id="fileupload" type="file" name="file" onChange={this.onChangeFile} accept=".csv, .pdf" /><input type="button" hidden={this.state.removeButtonHidden} onClick={this.removeFileAttachment} value="Remove File" />*/}
                    {/*        </StackItem>*/}
                    {/*    </Stack>*/}
                    {/*</div>*/}

                    {/* Footer Instructions */}
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        {/*<Text variant={"xLarge" as ITextProps['variant']}>Final Instructions</Text>*/}
                        <Text variant={"xLarge" as ITextProps['variant']}>{<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_footertitle }}></div>}</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            {<div className="content" dangerouslySetInnerHTML={{ __html: this.state.pt_footer }}></div>}
                        </Stack>
                    </div>

                    {/* Submit Button */}
                    <Stack>
                        <StackItem>
                            <PrimaryButton text="Submit F7 Notice" onClick={this.onSubmitForm} allowDisabledFocus />
                        </StackItem>
                    </Stack>
                </StackItem>


                {/*Saving block */}
                <StackItem style={{ display: this.state.formState == CommonModels.FormState.OnSave ? "block" : "none" }}>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Please wait one moment</Text>
                        <Separator alignContent="start"></Separator>
                        <div>
                            <Spinner label="Saving notice information..." ariaLive="assertive" labelPosition="top" />
                        </div>
                    </div>
                </StackItem>

                {/* Confirmation Block*/}
                <StackItem style={{ display: this.state.formState == CommonModels.FormState.SaveComplete ? "block" : "none" }}>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Text variant={"xLarge" as ITextProps['variant']}>Confirmation</Text>
                        <Separator alignContent="start"></Separator>
                        <Stack>
                            <StackItem>
                                <p>Thank you for submitting your notice to FMCS online. </p>
                                <p>Your submitted F-7 Notice has been emailed to the official filing this notice and to the chief negotiators/representatives of both parties. If you do not receive this email, please contact FMCS at <a href="mailto:F7notice@fmcs.gov">F7notice@fmcs.gov</a>.</p>
                                <p>Your notice was submitted on {new Date().toLocaleDateString()} {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                            </StackItem>
                            <StackItem>
                                <p>Your Confirmation Number is <strong>{this.state.f7record?.pt_ConfirmationNoticeNumber}</strong></p>
                                <p>* Please do not re-submit this notice by U.S. mail or fax.</p>
                            </StackItem>
                            <StackItem>
                                <p>&nbsp;</p>
                            </StackItem>
                            <StackItem>
                                <Link onClick={this.resetFormData}>Click here</Link> to submit another notice.
                            </StackItem>
                        </Stack>
                    </div>
                </StackItem>

                <StackItem>
                    &nbsp;
                </StackItem>

                <StackItem>
                    <sub><strong>Privacy Act Statement.</strong> 29 U.S.C. § 172, et seq., authorize the FMCS to require the reporting of this information. The primary
                        use of the information on this form is to allow FMCS officials to provide mediation services. Additional disclosures of the information on this
                        report may be made: (1) to a Federal, State, or local law enforcement agency if FMCS becomes aware of a violation or potential violation of law
                        or regulation; (2) to a court or party in a court or Federal administrative proceeding if the Government is a party or in order to comply with
                        a judge-issued subpoena; (3) to the National Archives and Records Administration or the General Services Administration in record management
                        inspections; (4) to the Office of Management and Budget during legislative coordination on private relief legislation; and (5) in a judicial or
                        administrative proceeding if the information is relevant to the subject matter.(6) This information may be used by FMCS to contact parties concerning
                        trainings, events, presentations, conferences, and other education opportunities and programs. This information will not be disclosed to any
                        requesting person unless authorized by law. Failure to provide the requested information could result in FMCS’s delay or inability to provide services.</sub>
                </StackItem>
                <StackItem>
                    &nbsp;
                </StackItem>
                <StackItem>
                    <sub><strong>Paperwork Reduction Act Notice.</strong> This information collection is authorized under the National Labor Relations Act (NLRA), 29 U.S.C. § 158(d)(3). 
                    The information you provide will be used to contact the parties involved and determine if mediation is warranted to help prevent or minimize disruption 
                    to commerce that could arise from a labor/management dispute. Providing this information is mandatory. The public reporting burden for this collection of 
                    information is estimated to average 10 minutes per response, including the time for reviewing instructions, gathering information, and completing and 
                    reviewing the collection of information. An agency may not conduct or sponsor, and a person is not required to respond to a collection of information 
                    unless it displays a currently valid OMB Control Number. The OMB Control Number for this information collection is 3076-0004, which expires 12-31-2027. 
                    Comments regarding this burden estimate or any other aspect of this collection of information, including suggestions for reducing this burden, may be sent to <a href="mailto:register@fmcs.gov">register@fmcs.gov</a> and reference the OMB Control Number. Note: Please do not return the completed collection or request assistance at this email address.</sub>
                </StackItem>
                {/* General Error Dialog*/}
                <Dialog
                    hidden={this.state.dialogHidden}
                    onDismiss={e => this.setState({ dialogHidden: true })}
                    maxWidth={'600px'}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Validation Error',
                        subText: 'Review the errors below and correct form fields as needed.',
                    }}
                    modalProps={{
                        isBlocking: true, styles: { main: {} }, dragOptions: {
                            moveMenuItemText: 'Move',
                            closeMenuItemText: 'Close',
                            menu: ContextualMenu,
                        }
                    }}>
                    <ul>
                        {this.state.errorMessages.map((item: any, index: number) => {
                            return <li>{(item.value as Array<string>).join(". ")}</li>
                        })}
                    </ul>
                    <DialogFooter>
                        <PrimaryButton onClick={e => this.setState({ dialogHidden: true })} text="Close" />
                    </DialogFooter>
                </Dialog>

                {/* Public Sector Dialog */}
                <Dialog
                    hidden={this.state.publicSectorDialog}
                    onDismiss={e => this.setState({
                        publicSectorDialog: true,
                        pt_nsector: this.state.sectors.filter(function (v: any, i: any) { return v.value == "Private Sector" })[0].key,
                        pt_nsectorlabel: "Private Sector"
                    })}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Public Sector ',
                    }}
                    modalProps={{
                        isBlocking: true, styles: { main: {} }, dragOptions: {
                            moveMenuItemText: 'Move',
                            closeMenuItemText: 'Cancel',
                            menu: ContextualMenu,
                        }
                    }}
                    containerClassName={'ms-dialogMainOverride PublicSector'}>

                    {/*The Public Sector (municipality, city, county, or state) should not file an F-7. */}
                    {/*If you need mediation assistance in your negotiations, use our portal submission form "<a href={this.state.publicSubmissionURL}>All Public Sector Service Requests</a>".*/}

                    The Public Sector (municipality, city, county, or state) should not file an F-7. If you need mediation assistance in your negotiations, send an email to <a href="mailto:clientservices@fmcs.gov">clientservices@fmcs.gov</a>.<br /><br />
                    To expedite your request, please provide the following information:<br />
                    1. Your contact information.<br />
                    2. Your L/M counterpart's contact information.<br />
                    3. Type of service requested (contract or grievance mediation, training, other and explain).<br />
                    4. Location (city/state) of the bargaining unit.<br />
                    5. Will the parties be in-person or virtual.<br />
                    6. Number of people expected to attend.
                </Dialog>

                {/* Federal Sector Dialog */}
                <Dialog
                    hidden={this.state.federalSectorDialog}
                    onDismiss={e => this.setState({
                        federalSectorDialog: true,
                        pt_nsector: this.state.sectors.filter(function (v: any, i: any) { return v.value == "Private Sector" })[0].key,
                        pt_nsectorlabel: "Private Sector"
                    })}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Federal Sector ',
                    }}
                    modalProps={{
                        isBlocking: true, styles: { main: {} }, dragOptions: {
                            moveMenuItemText: 'Move',
                            closeMenuItemText: 'Cancel',
                            menu: ContextualMenu,
                        }
                    }}
                    containerClassName={'ms-dialogMainOverride FederalSector'}>

                    {/*The Federal Sector (agencies or related unions) should not file an F-7. If you need mediation assistance in your negotiations, use our portal submission form*/}
                    {/*"<a href={this.state.federalSubmissionURL}>All Federal Sector Service Requests</a>".*/}

                    The Federal Sector (agencies or related unions) should not file an F-7. If you need mediation assistance in your negotiations, use our website
                    main page link "<a href="https://www.fmcs.gov/federalsectorrequest/" target="_blank">All Federal Sector Service Requests</a>".
                </Dialog>

                <StackItem>
                    &nbsp;
                </StackItem>
                <StackItem>
                    <div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <sub>Having issues with this page, please contact us for help at <a href="mailto:F7Notice@fmcs.gov">F7Notice@fmcs.gov</a>, or call us at (202) 606-5499.<br />
                            Have questions about our Services, please contact us for more information at <a href="mailto:ClientServices@fmcs.gov">ClientServices@fmcs.gov</a> or call us at 202-606-5499.
                        </sub>
                    </div>
                </StackItem>
            </Stack>

        )
    }
}